// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".payment-form__made-for[data-v-1f95aee7]{font-size:1rem;font-weight:400;line-height:1.5rem;margin-bottom:1.5rem;--tw-text-opacity:1;color:#64687e;color:rgba(100,104,126,var(--tw-text-opacity))}.payment-form__made-for b[data-v-1f95aee7]{font-weight:700}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
